import { Languages } from "../../types";
import { createIncomeRecordDictionary } from "./CreateIncomeRecord";
import { createPayableContractDictionary } from "./CreateServiceContract";
import { deleteContractDebitDictionary } from "./DeleteContractDebit";
import { incomeRecordsDictionary } from "./IncomeRecords";
import { payableContractDebitsDictionary } from "./PayableContractDebits";
import { payableContractsDictionary } from "./PayableContracts";
import { payableContractPaymentsDictionary } from "./PayablePayments";
import { PayableContractPagesDescriptions } from "./types";

export const getPayableContractDescriptions = (systemLang: Languages): PayableContractPagesDescriptions => ({
    PAYABLE_CONTRACTS: payableContractsDictionary[systemLang],
    CREATE_PAYABLE_CONTRACT: createPayableContractDictionary[systemLang],
    PAYABLE_CONTRACT_DEBITS: payableContractDebitsDictionary[systemLang],
    PAYABLE_CONTRACT_PAYMENTS: payableContractPaymentsDictionary[systemLang],
    DELTE_CONTRACT_DEBIT_RECORD: deleteContractDebitDictionary[systemLang],
    CREATE_INCOME_RECORD: createIncomeRecordDictionary[systemLang],
    INCOME_RECORDS: incomeRecordsDictionary[systemLang],
})